import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
const testimonialsData = [{
  quote: "The support from Helping Hands changed my life. I was able to start my own small business and provide for my children.",
  name: "Sarah Jenkins",
  service: "Community Grant Recipient",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/success_story_sarah.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/success_story_sarah.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/success_story_sarah.png-wvc-sizes"
}, {
  quote: "Seeing the direct impact of my donations through their field reports gives me total confidence in where my money goes.",
  name: "David Chen",
  service: "Monthly Donor",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/donor_portrait_david.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/donor_portrait_david.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/donor_portrait_david.png-wvc-sizes"
}, {
  quote: "They don't just provide aid; they provide hope and a sustainable path forward for entire villages in need.",
  name: "Elena Rodriguez",
  service: "Volunteer Coordinator",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/volunteer_story_elena.png",
  avatarSrcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/volunteer_story_elena.png-wvc-srcset",
  avatarSizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687075/img/volunteer_story_elena.png-wvc-sizes"
}];
export default function LivesTransformed() {
  return <section data-section-id="263359" id="lives-transformed" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-4xl font-black tracking-tighter text-primary md:text-5xl">
            Lives Transformed
          </h2>
        </div>

        <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 md:grid-cols-3">
          {testimonialsData.map((testimonial, index) => <Card key={index} data-index={index} className="flex h-full flex-col justify-between border-border bg-card shadow-lg transition-all duration-300 hover:scale-[1.02] hover:shadow-xl rounded-lg">
              <CardContent className="flex h-full flex-col items-center px-6 pb-8 pt-10 text-center">
                <p className="mb-8 flex-grow text-xl italic leading-relaxed text-muted-foreground font-default">
                  "{testimonial.quote}"
                </p>
                
                <div className="mt-auto flex items-center gap-4">
                  <SafeHydrate><Avatar className="size-14 border-2 border-chart-2/20">
                    <AvatarImage src={testimonial.avatar} data-wvc-srcset={testimonial.avatarSrcset} data-wvc-sizes={testimonial.avatarSizes} alt={`${testimonial.name} avatar`} className="object-cover" />
                    <AvatarFallback className="bg-chart-2/10 text-chart-2 font-bold">
                      {testimonial.name.charAt(0)}
                    </AvatarFallback>
                  </Avatar></SafeHydrate>
                  <div className="text-left">
                    <h4 className="font-default text-base font-bold text-primary">
                      {testimonial.name}
                    </h4>
                    <p className="text-xs font-semibold uppercase tracking-wider text-chart-2">
                      {testimonial.service}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}